import type * as lazyFullOption from './lazyFullOption';
import {
    optionTitle_mailHandling,
    optionSearch_mailHandling,
} from './MailHandlingOption.locstring.json';
import type { LazyOption } from 'owa-options-core';
import { createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';

const lazyFullModule: LazyModule<typeof lazyFullOption> = new LazyModule<typeof lazyFullOption>(
    () => import(/* webpackChunkName: "MailHandlingOption" */ './lazyFullOption'),
    { name: 'MailHandlingOption' }
);

const MailHandlingOption: LazyOption = createLazyOption(
    {
        key: 'mailHandlingOption',
        titleStringKey: optionTitle_mailHandling,
        searchTermsStringKey: optionSearch_mailHandling,
        isSupportedForAccount: mailboxInfo => !IsShadowMailboxUser(mailboxInfo),
        copilotSettingKey: 'junkemail',
    },
    lazyFullModule,
    m => m.default
);

export default MailHandlingOption;
